/**
 * La galeria de la ficha de producto no sobrevivia a un cambio de tamano de la ventana.
 *
 * El alto lo pone el CSS: `.woo-variation-product-gallery` mide `100vh - 132px`
 * (woocommerce/single-product/product-image.php), asi que al cargar la galeria ya
 * sigue al viewport. Lo que no seguia era el contenido: slick, en modo fade, escribe
 * ese alto en linea sobre su `.slick-list`, y a partir de ahi se muerde la cola. Los
 * hijos de la galeria llevan `height: 100%`, asi que cuando slick vuelve a medir el
 * slide para recolocarse obtiene el alto que el mismo dejo escrito y lo vuelve a
 * escribir igual: la galeria se queda con el alto de la carga para siempre. Al
 * agrandar la ventana la imagen queda corta y al reducirla se recorta por abajo
 * (medido en Bib Luz: imagen de 768px de alto dentro de una columna de 718px).
 *
 * Basta soltar ese alto para que la cadena de `height: 100%` se resuelva otra vez
 * contra el contenedor, que el CSS ya tiene bien, y pedirle a slick que se recoloque
 * con la medida nueva.
 *
 * Solo de lg para arriba, que es donde la galeria tiene ese alto propio contra el que
 * medir. Por debajo el alto lo manda el ancho de la columna y remedir ahi cambia la
 * foto de sitio (probado en movil: 358px de alto pasaban a 320px), asi que no se toca.
 * Las fichas de libros y de arte tampoco sufren el bloqueo: su cadena de altos lleva
 * `!important` y gana al valor en linea de slick, asi que se recolocan solas.
 *
 * Los 200 ms caen despues del resize de slick (50 ms) y antes de que el plugin vuelva
 * a fijar su `min-height` (300 ms), para que lo que acabe guardando sea ya el bueno.
 */
(function ($) {
    const SLIDER = '.woo-variation-gallery-slider';
    const ESPERA = 200;
    const DESKTOP = 1024;

    function remedirGalerias() {
        if (window.innerWidth < DESKTOP) {
            return;
        }

        document.querySelectorAll(SLIDER).forEach((slider) => {
            /* Solo la lista del carrusel grande: las miniaturas son otro slick con su
               propia `.slick-list`, y su alto no depende de la columna */
            const lista = slider.querySelector(':scope > .slick-list');

            if (lista) {
                lista.style.height = '';
            }

            /* El plugin guarda el tamano de la carga para que la ficha no de un salto
               mientras monta la galeria; pasado el resize esa medida ya no vale */
            const wrapper = slider.closest('.woo-variation-gallery-wrapper');

            if (wrapper) {
                wrapper.style.minHeight = '';
                wrapper.style.minWidth = '';
            }

            if (slider.classList.contains('slick-initialized')) {
                $(slider).slick('setPosition');
            }
        });
    }

    let temporizador = null;

    window.addEventListener('resize', () => {
        clearTimeout(temporizador);
        temporizador = setTimeout(remedirGalerias, ESPERA);
    });
})(jQuery);
